// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"Breadcrumbs_Breadcrumbs__Ivpv9","item":"Breadcrumbs_item__FiG3Z"};